export const APP_URLS = {
  dev: {
    api_crm: 'https://cp-api-crm.sitebuilder.latest.wzdev.co',
    crm: 'https://customersupport.sitebuilder.latest.wzdev.co',
    crmBillingUrls: {
      fortifi: 'https://builderstage.fortifi.cloud',
      gator: 'https://billing.qa.gatordev.co',
      uber: 'https://billing.qa.wzukltd.com'
    },
    'management-portal-api': 'https://management-api.sitebuilder.latest.wzdev.co'
  },
  qa: {
    api_crm: 'https://cp-api-crm.sitebuilder.qa.wzdev.co',
    crm: 'https://customersupport.sitebuilder.qa.wzdev.co',
    crmBillingUrls: {
      fortifi: 'https://builderstage.fortifi.cloud',
      gator: 'https://billing.qa.gatordev.co',
      uber: 'https://billing.qa.wzukltd.com'
    },
    'management-portal-api': 'https://management-api.sitebuilder.qa.wzdev.co'
  },
  uat: {
    api_crm: 'https://cp-api-crm.sitebuilder.uat.wzdev.co',
    crm: 'https://customersupport.sitebuilder.uat.wzdev.co',
    crmBillingUrls: {
      fortifi: 'https://builderstage.fortifi.cloud',
      gator: 'https://billing.qa.gatordev.co',
      uber: 'https://billing.qa.wzukltd.com'
    },
    'management-portal-api': 'https://management-api.sitebuilder.uat.wzdev.co'
  },
  prod: {
    api_crm: 'https://api.customersupport.mywebsitebuilder.com',
    crm: 'https://customersupport.mywebsitebuilder.com',
    crmBillingUrls: {
      fortifi: 'https://builder.fortifi.cloud',
      gator: 'https://billing.gator.com',
      uber: 'https://billing.wzukltd.com'
    },
    'management-portal-api': 'https://management-api.customersupport.mywebsitebuilder.com'
  }
}

export const getAppSpecificUrls = env => {
  if (!env) {
    console.error('Could not get the app urls because no env was specified.')
  }

  return APP_URLS[env]
}
